/* eslint-disable react-hooks/exhaustive-deps */
import Select from 'react-select';
import { useState, useRef } from 'react';
import { Accordion, Button, Card, Col, Container, Form, ProgressBar, Row, Table, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import { UseAlert } from 'hook/alert-hook';
import { Footer } from 'components/footer/footer-component';
import UploadFile, { UploadFileRef } from 'components/file/uploade-file-carga';
import { sleep } from 'helper/sleep-helper';
import LoadFile from 'service/load-file-service';
import { SelectOptionInterface } from '../../@types/entity/interface/select-option-interface';
import { ErroValidacao } from '../../@types/interfaces/analysis/charge/erro-validacao';
import { RestUseCase } from 'service/api/rest/rest-usecase';
import { UseAuth } from 'hook/auth-hook';
import { TableHeaderStyled } from 'pages/style/table/table-header';
import { getEnv } from 'helper/window-helper';
import { TitleGroupComponent } from '../../components/title/title-group-component';
import { useLoader } from "components/loader/loader-context";
import { BsDownload } from 'react-icons/bs';

type Props = {
  uploadFileAnalysis: (params: {
    file: File, isArquivoValidado: boolean 
  }) => Promise<any>
  uploadFileAnalysisValidate: (params: {
    file: File
  }) => Promise<any>
  uploadFileRegistrationInitial: (params: {
    file: File, isArquivoValidado: boolean
  }) => Promise<any>
  uploadFileRegistrationInitialValidate: (params: {
    file: File
  }) => Promise<any>
  uploadFileRegistrationInitialUsers: (params: {
    file: File,
    isArquivoValidado: boolean,
    users: string
  }) => Promise<any>
  exportFile: () => Promise<any>
  companyId: number
}

const titlePage = 'Carga de Arquivos';

const FileLoadPage: React.FC<Props> = ({ uploadFileAnalysis, uploadFileAnalysisValidate, uploadFileRegistrationInitial, uploadFileRegistrationInitialValidate, uploadFileRegistrationInitialUsers, exportFile, companyId }: Props) => {


  /**
   *
   * UPLOAD FILE
   *
   */
  const MAX_FILE_SIZE = 130 * 1024 * 1024;
  const NAME_FILE_DEFAULT = 'Nenhum arquivo selecionado';
  const [nameFile, updateFileName] = useState<string>(NAME_FILE_DEFAULT);
  const [typeFile, updateTypeFile] = useState<number>(10);
  const [processBar, updateProcessBar] = useState<number>(0);
  const [contentFile, updateContentFile] = useState<File | undefined>();
  const [mountUploadFile, updateMountUploadFile] = useState<boolean>(false);
  const [listModelReturnFile, updateListModelReturnFile] = useState<[]>([]);
  const [listaErros, setListaErros] = useState<ErroValidacao[]>([]);
  const [nomeArquivoDadosComErro, setNomeArquivoDadosComErro] = useState<string | null>(null);
  const [cargaAtual, setCargaAtual] = useState<string | null>(null);
  const [nomeArquivoLogErros, setNomeArquivoLogErros] = useState<string | null>(null);
  const [logErros, setLogErros] = useState<Uint8Array | null>(null);
  const [dadosComErro, setDadosComErro] = useState<Uint8Array | null>(null);
  const [listModelUsers, updateListModelUsers] = useState<SelectOptionInterface[]>([]);
  const { loggedUserData } = UseAuth();
  const [nomeFile, setNomeFile] = useState<string>("");
  const uploadFileRef = useRef<UploadFileRef>(null);
  const [isPreValidated, setIsPreValidated] = useState(false);

  const { showLoader, hideLoader } = useLoader();

  async function loadFile(file: File) {
    await cleanStatusBar();

    if (file !== null || file !== undefined) {
      updateContentFile(file);
      updateMountUploadFile(true);
      updateFileName(file.name);
    }
  }

  const typeFileOption: SelectOptionInterface[] = [
    { selected: false, value: 11, label: 'Cadastro Inicial' },
    { selected: false, value: 10, label: 'Análise' },
    { selected: false, value: 9, label: 'Análise Out. Usu.' },

  ];

  async function preValidate() {
    updateProcessBar(0);

    const numberOfColumns = 22;
    const lineSize = 302;
    const fileRead = contentFile!;
    const companyCode = companyId;
    const fileType = typeFile <= 10 ? 10 : 11;

    var resultReadingFile = await LoadFile(fileRead, lineSize, numberOfColumns, fileType, companyCode);

    updateProcessBar(resultReadingFile.readingProgress);

    await sleep(800);

    if (resultReadingFile.error != null) {
      showAlert({ show: true, content: resultReadingFile.error, color: 'danger' });
    } else {
      showAlert({ show: true, content: 'Arquivo processado e validado', color: 'success' });
    }
  }

  const cleanStatusBar = () => updateProcessBar(0);

  function clearField(): void {
    updateProcessBar(0);
    updateContentFile(undefined);
    updateMountUploadFile(false);
    updateFileName(NAME_FILE_DEFAULT);
    updateListModelReturnFile([]);
    setListaErros([])
    setNomeArquivoDadosComErro("")
    setNomeArquivoLogErros("")
    setCargaAtual("")
    setLogErros(null)
    setDadosComErro(null)
    uploadFileRef.current?.clearFileInput();
  }

  async function validateFile() {
    if (!contentFile) {
      showAlert({ show: true, content: 'Selecione um arquivo', color: 'danger', time: 2000 });
      return;
    }    
    /** inicia o loading */
    showLoader();    
    showAlert({ show: true, content: 'Aguarde um momento', color: 'warning', time: 2000 });

    updateListModelReturnFile([]);
    setListaErros([])
    setNomeArquivoDadosComErro("")
    setNomeArquivoLogErros("")
    setCargaAtual("")
    setLogErros(null)
    setDadosComErro(null)

    if (typeFile === 10 || typeFile === 9) {
      await uploadFileAnalysisValidate({ file: contentFile! })
        .then(response => {
          if (response !== undefined) {
            if (response.statusCode !== 500) {              
              updateListModelReturnFile([]);
              setListaErros(response.data.listaErros)
              setNomeArquivoDadosComErro(response.data.nomeArquivoDadosComErro)
              setNomeArquivoLogErros(response.data.nomeArquivoLogErros)
              setLogErros(response.data.logErros ? base64ToUint8Array(response.data.logErros) : new Uint8Array());
              setDadosComErro(response.data.dadosComErro ? base64ToUint8Array(response.data.dadosComErro) : new Uint8Array())
              setCargaAtual("(ANÁLISE)")
              showAlert({ show: true, content: response.message, color: 'success', time: 5000 });
            } else {
              showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
            }
          } else {
            showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
          }
        })
        .catch(() => showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 }));
    }  else {
      await uploadFileRegistrationInitialValidate({ file: contentFile! })
        .then(response => {
          if (response !== undefined) {
            if (response.statusCode !== 500) {
              updateListModelReturnFile([]);
              setListaErros(response.data.listaErros)
              setNomeArquivoDadosComErro(response.data.nomeArquivoDadosComErro)
              setNomeArquivoLogErros(response.data.nomeArquivoLogErros)
              setLogErros(base64ToUint8Array(response.data.logErros))
              setDadosComErro(base64ToUint8Array(response.data.dadosComErro))
              setCargaAtual("(INICIAL)")
              showAlert({ show: true, content: response.message, color: 'success', time: 5000 });
            } else {
              showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
            }
          } else {
            showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
          }
        })
        .catch(() => showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 }));
    }
    /** finaliza o loading */
    hideLoader();
  }

  async function sendFile() {
    if (!contentFile) {
      showAlert({ show: true, content: 'Selecione um arquivo', color: 'danger', time: 2000 });
      return;
    }    
    /** inicia o loading */
    showLoader();    
    showAlert({ show: true, content: 'Aguarde um momento', color: 'warning', time: 2000 });

    updateListModelReturnFile([]);
    setListaErros([])
    setNomeArquivoDadosComErro("")
    setNomeArquivoLogErros("")
    setCargaAtual("")
    setLogErros(null)
    setDadosComErro(null)

    if (typeFile === 10) {
      await uploadFileAnalysis({ file: contentFile!,  isArquivoValidado: isPreValidated})
        .then(response => {
          if (response !== undefined) {
            if (response.statusCode !== 500) {              
              updateListModelReturnFile(response.data.logCarga);
              setListaErros(response.data.listaErros)
              setNomeArquivoDadosComErro(response.data.nomeArquivoDadosComErro)
              setNomeArquivoLogErros(response.data.nomeArquivoLogErros)
              setLogErros(response.data.logErros ? base64ToUint8Array(response.data.logErros) : new Uint8Array());
              setDadosComErro(response.data.dadosComErro ? base64ToUint8Array(response.data.dadosComErro) : new Uint8Array())
              setCargaAtual("(ANÁLISE)")
              showAlert({ show: true, content: response.message, color: 'success', time: 5000 });
            } else {
              showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
            }
          } else {
            showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
          }
        })
        .catch(() => showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 }));
    } else if (typeFile === 9) {
      var userParams = '?';
      listModelUsers.forEach((value) => {
        if (value.selected === true) {
          userParams += `${encodeURIComponent('idsUsuarios[]')}=${value.value}&`;
        }
      });
      await uploadFileRegistrationInitialUsers({ file: contentFile!, isArquivoValidado: isPreValidated, users: userParams.substring(0, userParams.length - 1) })
        .then(response => {
          if (response !== undefined) {
            if (response.statusCode !== 500) {
              updateListModelReturnFile(response.data.logCarga);
              setListaErros(response.data.listaErros)
              setNomeArquivoDadosComErro(response.data.nomeArquivoDadosComErro)
              setNomeArquivoLogErros(response.data.nomeArquivoLogErros)
              setLogErros(response.data.logErros ? base64ToUint8Array(response.data.logErros) : new Uint8Array());
              setDadosComErro(response.data.dadosComErro ? base64ToUint8Array(response.data.dadosComErro) : new Uint8Array())
              setCargaAtual("(ANÁLISE)")
              showAlert({ show: true, content: response.message, color: 'success', time: 5000 });
            } else {
              showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
            }
          } else {
            showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
          }
        })
        .catch(() => showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 }));
    } else {
      await uploadFileRegistrationInitial({ file: contentFile!,  isArquivoValidado: isPreValidated })
        .then(response => {
          if (response !== undefined) {
            if (response.statusCode !== 500) {
              updateListModelReturnFile(response.data.logCarga);
              setListaErros(response.data.listaErros)
              setNomeArquivoDadosComErro(response.data.nomeArquivoDadosComErro)
              setNomeArquivoLogErros(response.data.nomeArquivoLogErros)
              setLogErros(base64ToUint8Array(response.data.logErros))
              setDadosComErro(base64ToUint8Array(response.data.dadosComErro))
              setCargaAtual("(INICIAL)")
              showAlert({ show: true, content: response.message, color: 'success', time: 5000 });
            } else {
              showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
            }
          } else {
            showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 });
          }
        })
        .catch(() => showAlert({ show: true, content: 'Ops!!! Algo deu errado tente novamente mais tarde...', color: 'danger', time: 2000 }));
    }
    /** finaliza o loading */
    hideLoader();
  }

  async function listAllUserByCompanies(): Promise<any> {

    const ENDPOINT_USERS = getEnv('REACT_APP_END_POINT_USER')!;
    const companiesActive = true;

    let query = `?empresa=${loggedUserData?.companyId}&ativo=${companiesActive}`;
    let queryByRole = `${query}&roles=COMPRAS_GESTOR&roles=COMPRAS_OPERACIONAL&roles=SCRAP_COMPRADOR`;

    let responseUser: any[] = await new RestUseCase(ENDPOINT_USERS! + query).Get()
      .then((response) => {
        return response.body;
      });

    let responseUserByRoles: any[] = await new RestUseCase(ENDPOINT_USERS! + queryByRole).Get()
      .then((res) => {
        return res.body;
      });

    let Users = responseUser.map((value: any) => {
      const exists = checkObjectExists(value, responseUserByRoles);
      return {
        value: value.id, label: value.nome, selected: exists,
      };
    });

    updateListModelUsers(Users);
  }

  function checkObjectExists(obj: any, array: any[]): boolean {
    return array.some(item => item.id === obj.id);
  }

  function handleDownloadDadosComErro() {
    if (!dadosComErro || !nomeArquivoDadosComErro) return;

    const blob = new Blob([dadosComErro], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivoDadosComErro;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url); // limpa a URL temporária
  }

  function base64ToUint8Array(base64: string): Uint8Array {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }


  function handleDownloadLogErros() {
    if (!logErros || !nomeArquivoLogErros || logErros.length === 0) return;

    const blob = new Blob([logErros], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivoLogErros;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }


  /**
   *
   * ALERT / ALERT MODAL
   *
   */
  const { showAlert } = UseAlert();

  function handleSelectTypeItem(params: number) {
    updateTypeFile(params);
  }

  function handleCheckbox(value: number) {
    updateListModelUsers(listModelUsers.map(item => {
      if (item.value === value) {
        item.selected = item.selected === true ? false : true;
      }
      return item;
    }));
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsPreValidated(event.target.checked);
  };

  /**
   *
   * RENDER
   *
   */
  return (
    <>
      <Container>
        <TitleGroupComponent titlePage={titlePage}>
          <Row>
            <Col>
            </Col>
          </Row>
        </TitleGroupComponent>

        {<Card>
          <Card.Body>
            <Container>
              <Row className='mt-3'>
                <Col md={3}>
                  <Form.Label>Tipo do arquivo:</Form.Label>
                  <Select
                    defaultValue={typeFileOption[1]}
                    onChange={val => {
                      updateListModelUsers([]);
                      if (val?.label === 'Análise Out. Usu.') {
                        listAllUserByCompanies();
                      }

                      handleSelectTypeItem(val?.value);
                    }}
                    options={typeFileOption}
                  />
                </Col>
                {listModelUsers.length > 0 ?
                  <>
                    <Accordion className='mt-3' defaultActiveKey='0'>
                      <Accordion.Item eventKey='0'>
                        <Accordion.Header>Usuários</Accordion.Header>
                        <Accordion.Body>
                          <Row>
                            {listModelUsers.map((checkboxValue, index) => {
                              return (
                                <Col key={index} md={6}>
                                  <Form.Check label={checkboxValue.label} type='checkbox' value={checkboxValue.value}
                                    checked={checkboxValue.selected} onChange={(e) => {
                                      handleCheckbox(Number(e.target.value));
                                    }} />
                                </Col>
                              );
                            })}
                          </Row>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </>
                  :
                  <></>
                }

              </Row>
              <Row className='mt-3'>
                <Col>
                  <Card className='py-5 mb-4' style={{ backgroundColor: '#F0F0F0', border: 'none' }}>
                    <Row className='d-flex justify-content-center mb-5'>
                      <svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' fill='currentColor'
                        className='bi bi-file-earmark-text' viewBox='0 0 16 16' color='#0433BF'>
                        <path
                          d='M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z' />
                        <path
                          d='M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z' />
                      </svg>
                    </Row>
                    <Row className='d-flex justify-items-center m-auto mb-2'>
                      <span>{nameFile}</span>
                    </Row>
                    <UploadFile
                      ref={uploadFileRef}
                      setNomeFile={setNomeFile}
                      setContentFile={updateContentFile}
                    />
                  </Card>
                </Col>
              </Row>
              <div>
                <Button variant='primary' size='sm' type='submit' onClick={sendFile}>Carregar</Button>
                <Button className='mx-1' variant='outline-primary' size='sm' onClick={validateFile}>Pré validar</Button>
                <Button variant='outline-primary' size='sm' onClick={clearField}>Limpar</Button>
                <Form.Group controlId="prevalidated-check" className="mt-2 d-flex align-items-start">
  <Form.Check
    type="checkbox"
    label="Carga já pré-validada?"
    checked={isPreValidated}
    onChange={handleCheckboxChange}
  />

  <OverlayTrigger
    placement="right"
    overlay={
      <Tooltip id="tooltip-prevalidated">
        Marque esta opção caso o arquivo já tenha sido previamente validado e corrigido. Dessa forma, o processamento dos dados será mais rápido.
      </Tooltip>
    }
  >
    <span
      className="ms-1 text-primary"
      style={{
        fontSize: '0.75em',         // reduz o tamanho para parecer elevado
        transform: 'translateY(-0.4em)', // eleva verticalmente
        cursor: 'pointer',
      }}
    >
      <InfoCircle />
    </span>
  </OverlayTrigger>
</Form.Group>
              </div>
              {isPreValidated && (
                  <div className="mt-2">
                    <Alert variant="danger" className="fw-bold">
                      Atenção: ao marcar esta opção sem validar previamente o arquivo, a carga poderá conter erros que comprometam o processamento dos dados.
                    </Alert>
                  </div>
                )}
            </Container>            
            <CreatAcordion />
          </Card.Body>
        </Card>
        }

      </Container>
      <Footer />
    </>
  );

  /**
   *
   * CREATE TABLE DADOS PROCESSADOS
   *
   */
  interface TableProps {
    listModelReturnFile: any[];
  }
  function CreateTable(props: TableProps) {
    const { listModelReturnFile } = props;
    return (
      <>
        {listModelReturnFile.length > 0
          ?
          <Container className='mt-3'>
            <div><h6>STATUS DOS DADOS PROCESSADOS</h6></div>
            <TableHeaderStyled>
              <Table>
                <thead>
                  <tr>
                    <th>status</th>
                    <th>Quantidade</th>
                    <th>Mensagem</th>
                  </tr>
                </thead>
                <tbody>
                  {listModelReturnFile.map((value: any, index) => {
                    return (
                      <tr key={index}>
                        <td>{value.lacStrStatus}</td>
                        <td>{value.lacIntQuantidade}</td>
                        <td>{value.lacStrMensagem}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </TableHeaderStyled>
          </Container>
          :
          <></>

        }
      </>
    );
  }

  /**
   *
   * CREATE TABLE LOGS
   *
   */

  interface ErrorsTableProps {
    listaErros: ErroValidacao[];  // Tipo da prop - array de ErroValidacao
  }

  function CreateErrorsTable(props: ErrorsTableProps) {
    const { listaErros } = props;

    return (
      <>
        {listaErros && listaErros.length > 0 ? ( // Verifica se a lista não está vazia
          <Container className='mt-3'>
            <div><h6>LISTA DE ERROS</h6></div>
            <TableHeaderStyled>
              <Table>
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Descrição do Erro</th>
                    <th>Linha</th>
                  </tr>
                </thead>
                <tbody>
                  {listaErros.map((erro, index) => (
                    <tr key={index}>
                      <td>{erro.campo}</td>
                      <td>{erro.descricaoErro}</td>
                      <td>{erro.linha}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableHeaderStyled>
          </Container>
        ) : (
          <></> // Renderiza vazio se a lista estiver vazia
        )}
      </>
    );
  }

  function BotoesLog() {
    return (
      <Row className="mt-2">
        <Col xs="auto" className="pe-2"> {/* Use xs="auto" para ajustar a largura ao conteúdo e pe-2 para padding right */}
          <Button
            variant="primary"
            size="sm"  // Adicione size="sm" para o tamanho pequeno
            onClick={handleDownloadDadosComErro}
            disabled={!dadosComErro || dadosComErro.length === 0}
          >
            Dados com Erro <BsDownload className="ms-1" />
          </Button>
        </Col>
        <Col xs="auto" className="ps-2"> {/* Use xs="auto" e ps-2 para padding left */}
          <Button
            variant="primary"
            size="sm"  // Adicione size="sm" para o tamanho pequeno
            onClick={handleDownloadLogErros}
            disabled={!logErros || logErros.length === 0}
          >
            Log de Erros <BsDownload className="ms-1" />
          </Button>
        </Col>
      </Row>
    )
  }

  /**
     *
     * CREATE ACORDION DO RETORNO DA CARGA
     *
     */
  function CreatAcordion() {
    return (
    <>
      <div style={{ marginTop: '10px' }}>
        <h6 style={{
          padding: '10px',
          margin: '0',
          fontSize: '1.2rem',
          color: '#333',
          textAlign: 'center',
          backgroundColor: '#f0f0f0',
          borderRadius: '5px',
          marginBottom: '6px'
        }}>
          DADOS DE RETORNO DA CARGA {cargaAtual}
        </h6>
      </div>

      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Status dos dados processados</Accordion.Header>
          <Accordion.Body>
            <CreateTable listModelReturnFile={listModelReturnFile} />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Logs de erro</Accordion.Header>
          <Accordion.Body>
            <CreateErrorsTable listaErros={listaErros} />
            <BotoesLog />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
  }
};

export default FileLoadPage;
